import React from "react";
import SessionValidation from "../../context/SessionValidationContext";
import { loginRequest } from "../../auth/authConfig";

import {
  LoadingIndicator,
  Typography,
} from "@anchor/react-components/dist/lib/components";
import ButtonGenerator from "../ButtonFactory/ButtonGenerator";
import { useMsal } from "@azure/msal-react";
import sesionexpiredImages from "../../assets/Images/aboutUsPageImage.png";

function UnAuthenticatedAppBody() {
  const { sessionExpired } = SessionValidation();
  const { instance, accounts } = useMsal();
  return (
    <>
      {sessionExpired ? (
        <div className="session-expired" style={{}}>
          <img
            style={{ width: "100%", height: "100vh", position: "absolute" }}
            src={sesionexpiredImages}
            alt="seesion-expired-image"
          />
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              height: "100vh",
              paddingLeft: "20px",
            }}
          >
            <Typography
              variant="h1"
              style={{
                color: "white",
                fontWeight: "bold",
                position: "absolute",
                zIndex: "1",
              }}
            >
              Session Expired!
            </Typography>
            <div
              style={{
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                paddingTop: "10%",
              }}
            >
              <ButtonGenerator
                appearance="primary"
                id="primary"
                justifyItems="center"
                label="Refresh"
                name="primary"
                onClick={() =>
                  instance.acquireTokenPopup({
                    ...loginRequest,
                    account: accounts[0],
                  })
                }
                title="Login"
                variant="filledAlt"
                style={{ width: "140px", fontSize: "20px" }}
              />
            </div>
          </div>
        </div>
      ) : (
        <div
          style={{
            width: "100%",
            height: "90vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <LoadingIndicator
            appearance="default"
            fit="medium"
            id="testing"
            label="SSO Authenticating"
            variant="spinner"
          />
        </div>
      )}
    </>
  );
}

export default UnAuthenticatedAppBody;
